/*
 * @Author: LZH
 * @Date: 2025-08-04 11:52:21
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-08-05 15:23:30
 * @Description:
 */
export default {
  Problem_feedback: '請輸入問題和建議',
  contact_information: '請輸入聯繫方式',
  contact_information_the: '聯繫方式請輸入',
  import: '輸入',
  Please_enter: '請輸入',
  Old_password: '舊密碼',
  New_password: '新密碼',
  Required: '必填',
  Enteranewpassword: '輸入新密碼',
  Confirm_new_password: '確認新密碼',
  mobile: '手機號碼',
  QQ: 'QQ號碼',
  postbox: '電子郵件信箱',
  contact_you: '方便聯繫到您',
  question: '請輸入您的問題',
  Characters_up: '6-16個字元',
  address: '請輸入詳細地址',
  renewal_contact: '請輸入續費聯繫方式',
  ple_contact_name: '請輸入聯繫人姓名',
  Please_enter_withdrawal: '請輸入收回',
  Number_of_cards: '的數量',
  Pleasechooseanagent: '請選擇代理商',
  Pleaseenterthequantity: '請輸入數量',
  Pleaseentertheuserprefixnickname: '請輸入用戶前綴暱稱（2-26位）',
  PleaseEnterImei: '請輸入15位數IMEI號碼',
  Remarkswithin: '備註：100字以內',
  Pleaseselectaunit: '請選擇公司',
  Pleaseselectagrouptojoin: '請選擇要加入的群組',
  Pleaseentertheunitname: '請輸入公司名稱',
  companynamerequired: '（必填：4-20文字、字母、數字）',
  Pleaseenterloginaccount: '請輸入登錄帳戶',
  loginaccountrequired: '（必填：6-20位字母、數字）',
  Pleaseenteryourpassword: '請輸入登錄密碼',
  loginpasswordrequired: '（必填：2-10文字、字母、數字）',
  Pleaseenteracontactname: '請輸入連絡人姓名',
  contactnamerequired: '（必填：2-10文字、字母、数字）',
  Pleaseenteraprefixname: '請輸入前綴名稱',
  prefixnamerequired: '(必填：2-12文字、字母、數字)',
  Contactnamerequired20: '連絡人姓名（必填：2-20個字元）',
  mobilephonenumber: '手機號碼（可選）',
  Enteremailaddress: '輸入電子郵件信箱地址（選擇）',
  Enterdetailedaddress: '輸入詳細地址（選擇）',
  Pleaseenteragroupname: '請輸入群組名稱（必填：2-15字元）',
  Groupnamerequired: '群組名稱（必填：2-15個字元）',
  Pleasetypeyourphonenumber: '請輸入聯繫電話',
  Pleaseinputtheemailaddress: '請輸入電子郵件地址',
  Pleaseenterthemailingaddress: '請輸入通訊地址',
  RequiredPleaseenterusernickname: '（必填）請輸入用戶昵稱',
  Pleasemobilephonenumber: '（可選）請輸入11位數手機號碼',
  PleaseentertheoriginalIMEInumber: '請輸入15位數IMEI原始號碼',
  PleaseenterthenewIMEInumber: '請輸入15位數IMEI新號碼',
  Pleaseenteraverificationcode: '請輸入4位數驗證碼',
  Pleaseenterthemobilephonenumbertobebound: '請輸入要綁定的手機號碼',
  PleaseenteragroupnameTow: '請輸入群組名稱',
  Pleaseenterusername: '請輸入用戶名稱',
  Fencenamerequired: '圍欄名稱（必填：1-15個字元）',
  Pleaseenterthefencename: '請輸入圍欄名稱',
  Pleaseselectatime: '請選擇時間',

  please_rest_password: '您好,為了您的帳號安全,建議先重設登入密碼',
  TheLastGroupUnderTheUnitCannotBeDeleted: '單位下最後一個群組不可以刪除',
}
